/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useTheme, Box, Tabs, Tab } from '@mui/material';
import { colorTheme } from 'theme';
import { useState } from 'react';
import UploadsGrid from './UploadsGrid';
import NonReconciledTransactionsGrid from './NonReconciledTransactionsGrid';
import OtherPaymentsGrid from './OtherPaymentsGrid';

export interface UploadFileType {
  contributionFileId: number;
  fileName: string;
  key: string;
  employeeId: number;
  createdAt: Date;
}
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps): JSX.Element {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3, height: '75vh' }}>{children}</Box>}
    </div>
  );
}

const Uploads = (): JSX.Element => {
  const [value, setValue] = useState(0);
  const handleChange = (
    event: React.SyntheticEvent,
    newValue: number,
  ): void => {
    setValue(newValue);
  };
  const theme = useTheme();
  const colors = colorTheme(theme.palette.mode);

  return (
    <Box>
      <Box
        sx={{
          maxWidth: {
            xs: 320,
            sm: 480,
            md: '100%',
          },
          borderRadius: 3,
          px: 2,
          boxShadow: 2,
          bgcolor: 'background.paper',
        }}
      >
        <Tabs
          value={value}
          onChange={handleChange}
          variant="scrollable"
          indicatorColor="secondary"
          scrollButtons="auto"
          aria-label="scrollable auto tabs example"
          TabIndicatorProps={{
            style: {
              backgroundColor: colors.greenAccent[600],
            },
          }}
          sx={{
            '& .MuiTab-root.Mui-selected': {
              color: colors.greenAccent[500],
            },
          }}
        >
          <Tab label="Bank Files Dashboard" />
          <Tab label="Non Reconciled Transaction" />
          <Tab label="Other Payments" />
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        <UploadsGrid />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <NonReconciledTransactionsGrid />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <OtherPaymentsGrid />
      </TabPanel>
    </Box>
  );
};

export default Uploads;
